import { type Till } from "~/api/tills/types";

// Type for tills that have attended sell config (attended or collect types)
type TillWithAttendedSellConfig = Extract<
  Till,
  { type: "attended" | "collect" }
>;

/**
 * Type guard function that checks if a till has attended sell configuration.
 * After calling this function, TypeScript will know that the till is of type "attended" or "collect"
 * and has the skipReceiptPage config property available.
 */
export function hasAttendedSellConfig(
  till: Till | null | undefined
): till is TillWithAttendedSellConfig {
  if (!till) return false;

  return till.type === "attended" || till.type === "collect";
}
